interface ScrollingMessageProps {
  text: string;
  size?: 'small' | 'medium' | 'large';
  speed?: 'static' | 'slow' | 'medium' | 'fast';
}

const MESSAGE_SIZES = {
  small: '1.2rem',
  medium: '1.5rem',
  large: '1.8rem'
};

const MESSAGE_SPEEDS = {
  static: 0,
  slow: 75,
  medium: 37.5,
  fast: 18.75
};

export function ScrollingMessage({ 
  text, 
  size = 'medium', 
  speed = 'medium' 
}: ScrollingMessageProps) {
  if (!text) return null;
  
  const fontSize = MESSAGE_SIZES[size];
  const duration = MESSAGE_SPEEDS[speed];
  
  if (speed === 'static') {
    return (
      <div className="bg-gradient-to-r from-yellow-500 to-yellow-400 px-8 py-4 border-t-4 border-yellow-300">
        <div className="text-center">
          <div 
            className="font-bold text-black tracking-wide"
            style={{ fontSize }}
          >
            {text}
          </div>
        </div>
      </div>
    );
  }
  
  return (
    <div className="bg-gradient-to-r from-yellow-500 to-yellow-400 px-8 py-4 border-t-4 border-yellow-300 overflow-hidden">
      <div 
        className="font-bold text-black tracking-wide whitespace-nowrap animate-scroll"
        style={{ 
          fontSize,
          animation: `scroll ${duration}s linear infinite`
        }}
      >
        {text} • {text} • {text}
      </div>
    </div>
  );
}
